import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { 
    ROUTE_ADMINISTRATION_GROUP,
    DOSAGE_FORM_GROUP,
    ROUTE_ADMINISTRATION,
    DOSAGE_FORM, 
    DISPENSING_UNIT,
    UNSPSC,
    UNSPSC_FAMILY,
    UNSPSC_CLASS,
    ACTIVE_INGREDIENT_CODE20,
    DOSAGE_FORM_CODE20,
    MED_DESCRIPTION_CODE20,
    SOURCE_CODE20,
    PROJECT,
    ARTICLE_CODE22,
    MED_DESCRIPTION_CODE22,
    BIDDER,
    PROCESS_CODE,
    COUNTRY_BID,
    ARTICLE_TYPE,
    ARTICLE_GROUP,
    COUNTRY_SUPPLIER,
    SUPPLIER_TYPE,
    PUBLICATION_TYPE,
    PUBLICATION_FORMAT,
    PUBLICATION_STATUS,
    PUBLICATION_PROJECT,
    COUNTRY_OPENNING,
    PROCESS_CODE_BID,
    COUNTRY_SOURCE_CODE22,
    MED_DESCRIPTION_CODE22_ORP,
    SOURCE_CODE22,
    PROCCESS_YEAR,
    ANIO_PRICE_CODE22,
    PROCESS_CODE_BIDDER,
    PROCCESS_YEAR_BIDDER,
    LOTE_STATE,
    YEAR_DEMAND,
    YEAR_GOB360,
    INSTITUTION_GOB360,
    PROCESS_CODE_OPENING,
    UNIT_PRICE,
    UNIT_PRICE_TRANSACCIONES,
    LIST_ARTICLE_ORP_CODE22,
    LIST_ARTICLE_CODE_COUNTRY,
    LIST_ARTICLE_CODE_COUNTRY_BIDDER,
    COUNTRY_TAB_AWARD,
    PROCCESS_CODE_TAB_AWARD,
    YEAR_TAB_AWARD,
    PROCCESS_CODE_TAB_OPENNING,
    YEAR_TAB_OPENNING,
    COUNTRY_TAB_OPENNING,
    ARTICLE_CODE22_SUPPLIER,
    ARTICLE_CODE_COUNTRY_SUPPLIER,
    COUNTRY_SUPPLIER_INFO,
    SUPPLIER_INFO,
    MED_DESCRIPTION_RAZONABILIDAD,
    LIST_ARTICLE_RAZONABILIDAD,
    COUNTRY_AWARD,
    ROLE,
    ROLE_ORP
} from '../actions';

import {
    RouteAdministrationGroupSuccess,
    RouteAdministrationGroupError,
    DosageFormGroupSuccess,
    DosageFormGroupError,
    RouteAdministrationSuccess,
    RouteAdministrationError,
    DosageFormSuccess,
    DosageFormError,
    DispensingUnitSuccess,
    DispensingUnitError,
    UnspscSuccess,
    UnspscError,
    UnspscFamilySuccess,
    UnspscFamilyError,
    UnspscClassSuccess,
    UnspscClassError,
    ActiveIngredientCode20Success,
    ActiveIngredientCode20Error,
    DosageFormCode20Success,
    DosageFormCode20Error,
    MedDescriptionCode20Success,
    MedDescriptionCode20Error,
    SourceCode20Success,
    SourceCode20Error,
    ProjectSuccess,
    ProjectError,
    ArticleCode22Success,
    ArticleCode22Error,
    BidderSuccess,
    BidderError,
    ProcessCodeSuccess,
    ProcessCodeError,
    CountryBidSuccess,
    CountryBidError,
    MedDescriptionCode22Success,
    MedDescriptionCode22Error,
    ArticleTypeSuccess,
    ArticleTypeError,
    ArticleGroupSuccess,
    ArticleGroupError,
    CountrySupplierSuccess,
    CountrySupplierError,
    SupplierTypeSuccess,
    SupplierTypeError,
    PublicationTypeSuccess,
    PublicationTypeError,
    PublicationFormatSuccess,
    PublicationFormatError,
    PublicationStatusSuccess,
    PublicationStatusError,
    PublicationProjectSuccess,
    PublicationProjectError,
    CountryOpenningSuccess,
    CountryOpenningError,
    ProcessCodeBidSuccess,
    ProcessCodeBidError,
    CountrySourceCode22Success,
    CountrySourceCode22Error,
    MedDescriptionCode22OrpSuccess,
    MedDescriptionCode22OrpError,
    SourceCode22Success,
    SourceCode22Error,
    ProccessYearSuccess,
    ProccessYearError,
    AnioPriceCode22Success,
    AnioPriceCode22Error,
    ProcessCodeBidderSuccess,
    ProcessCodeBidderError,
    ProccessYearBidderSuccess,
    ProccessYearBidderError,
    LoteStateSuccess,
    LoteStateError,
    YearDemandSuccess,
    YearDemandError,
    YearGob360Success,
    YearGob360Error,
    InstitutionGob360Success,
    InstitutionGob360Error,
    ProcessCodeOpeningSuccess,
    ProcessCodeOpeningError,
    UnitPriceSuccess,
    UnitPriceError,
    UnitPriceTransaccionesSuccess,
    UnitPriceTransaccionesError,
    ListArticleOrpCode22Success,
    ListArticleOrpCode22Error,
    ListArticleCodeCountrySuccess,
    ListArticleCodeCountryError,
    ListArticleCodeCountryBidderSuccess,
    ListArticleCodeCountryBidderError,
    CountryTabAwardSuccess,
    CountryTabAwardError,
    ProccessCodeTabAwardSuccess,
    ProccessCodeTabAwardError,
    YearTabAwardSuccess,
    YearTabAwardError,
    ProccessCodeTabOpenningSuccess,
    ProccessCodeTabOpenningError,
    YearTabOpenningSuccess,
    YearTabOpenningError,
    CountryTabOpenningSuccess,
    CountryTabOpenningError,
    ArticleCode22SupplierSuccess,
    ArticleCode22SupplierError,
    ArticleCodeCountrySupplierSuccess,
    ArticleCodeCountrySupplierError,
    CountrySupplierInfoSuccess,
    CountrySupplierInfoError,
    SupplierInfoSuccess,
    SupplierInfoError,
    MedDescriptionRazonabilidadSuccess,
    MedDescriptionRazonabilidadError,
    ListArticleRazonabilidadSuccess,
    ListArticleRazonabilidadError,
    CountryAwardSuccess,
    CountryAwardError,
    RoleSuccess,
    RoleError,
    RoleOrpSuccess,
    RoleOrpError
} from '../actions';


export function* watchRouteAdministrationGroup() {
    yield takeEvery(ROUTE_ADMINISTRATION_GROUP, onRouteAdministrationGroup);
}

export function* watchDosageFormGroup() {
    yield takeEvery(DOSAGE_FORM_GROUP, onDosageFormGroup);
}

export function* watchRouteAdministration() {
    yield takeEvery(ROUTE_ADMINISTRATION, onRouteAdministration);
}

export function* watchDosageForm() {
    yield takeEvery(DOSAGE_FORM, onDosageForm);
}

export function* watchDispensingUnit() {
    yield takeEvery(DISPENSING_UNIT, onDispensingUnit);
}

export function* watchUnspsc() {
    yield takeEvery(UNSPSC, onUnspsc);
}

export function* watchUnspscFamily() {
    yield takeEvery(UNSPSC_FAMILY, onUnspscFamily);
}

export function* watchUnspscClass() {
    yield takeEvery(UNSPSC_CLASS, onUnspscClass);
}

export function* watchActiveIngredientCode20() {
    yield takeEvery(ACTIVE_INGREDIENT_CODE20, onActiveIngredientCode20);
}

export function* watchDosageFormCode20() {
    yield takeEvery(DOSAGE_FORM_CODE20, onDosageFormCode20);
}

export function* watchMedDescriptionCode20() {
    yield takeEvery(MED_DESCRIPTION_CODE20, onMedDescriptionCode20);
}

export function* watchSourceCode20() {
    yield takeEvery(SOURCE_CODE20, onSourceCode20);
}

export function* watchProject() {
    yield takeEvery(PROJECT, onProject);
}

export function* watchArticleCode22() {
    yield takeEvery(ARTICLE_CODE22, onArticleCode22);
}

export function* watchBidder() {
    yield takeEvery(BIDDER, onBidder);
}

export function* watchProcessCode() {
    yield takeEvery(PROCESS_CODE, onProcessCode);
}

export function* watchCountryBid() {
    yield takeEvery(COUNTRY_BID, onCountryBid);
}

export function* watchMedDescriptionCode22() {
    yield takeEvery(MED_DESCRIPTION_CODE22, onMedDescriptionCode22);
}

export function* watchArticleType() {
    yield takeEvery(ARTICLE_TYPE, onArticleType);
}

export function* watchArticleGroup() {
    yield takeEvery(ARTICLE_GROUP, onArticleGroup);
}

export function* watchCountrySupplier() {
    yield takeEvery(COUNTRY_SUPPLIER, onCountrySupplier);
}

export function* watchSupplierType() {
    yield takeEvery(SUPPLIER_TYPE, onSupplierType);
}

export function* watchPublicationType() {
    yield takeEvery(PUBLICATION_TYPE, onPublicationType);
}

export function* watchPublicationFormat() {
    yield takeEvery(PUBLICATION_FORMAT, onPublicationFormat);
}

export function* watchPublicationStatus() {
    yield takeEvery(PUBLICATION_STATUS, onPublicationStatus);
}

export function* watchPublicationProject() {
    yield takeEvery(PUBLICATION_PROJECT, onPublicationProject);
}

export function* watchCountryOpenning() {
    yield takeEvery(COUNTRY_OPENNING, onCountryOpenning);
}

export function* watchProcessCodeBid() {
    yield takeEvery(PROCESS_CODE_BID, onProcessCodeBid);
}

export function* watchCountrySourceCode22() {
    yield takeEvery(COUNTRY_SOURCE_CODE22, onCountrySourceCode22);
}

export function* watchMedDescriptionCode22Orp() {
    yield takeEvery(MED_DESCRIPTION_CODE22_ORP, onMedDescriptionCode22Orp);
}

export function* watchSourceCode22() {
    yield takeEvery(SOURCE_CODE22, onSourceCode22);
}

export function* watchProccessYear() {
    yield takeEvery(PROCCESS_YEAR, onProccessYear);
}

export function* watchAnioPriceCode22() {
    yield takeEvery(ANIO_PRICE_CODE22, onAnioPriceCode22);
}

export function* watchProcessCodeBidder() {
    yield takeEvery(PROCESS_CODE_BIDDER, onProcessCodeBidder);
}

export function* watchProccessYearBidder() {
    yield takeEvery(PROCCESS_YEAR_BIDDER, onProccessYearBidder);
}

export function* watchLoteState() {
    yield takeEvery(LOTE_STATE, onLoteState);
}

export function* watchYearDemand() {
    yield takeEvery(YEAR_DEMAND, onYearDemand);
}

export function* watchYearGob360() {
    yield takeEvery(YEAR_GOB360, onYearGob360);
}

export function* watchInstitutionGob360() {
    yield takeEvery(INSTITUTION_GOB360, onInstitutionGob360);
}

export function* watchProcessCodeOpening() {
    yield takeEvery(PROCESS_CODE_OPENING, onProcessCodeOpening);
}

export function* watchUnitPrice() {
    yield takeEvery(UNIT_PRICE, onUnitPrice);
}

export function* watchUnitPriceTransacciones() {
    yield takeEvery(UNIT_PRICE_TRANSACCIONES, onUnitPriceTransacciones);
}

export function* watchListArticleOrpCode22() {
    yield takeEvery(LIST_ARTICLE_ORP_CODE22, onListArticleOrpCode22);
}

export function* watchListArticleCodeCountry() {
    yield takeEvery(LIST_ARTICLE_CODE_COUNTRY, onListArticleCodeCountry);
}

export function* watchListArticleCodeCountryBidder() {
    yield takeEvery(LIST_ARTICLE_CODE_COUNTRY_BIDDER, onListArticleCodeCountryBidder);
}

export function* watchCountryTabAward() {
    yield takeEvery(COUNTRY_TAB_AWARD, onCountryTabAward);
}

export function* watchProccessCodeTabAward() {
    yield takeEvery(PROCCESS_CODE_TAB_AWARD, onProccessCodeTabAward);
}

export function* watchYearTabAward() {
    yield takeEvery(YEAR_TAB_AWARD, onYearTabAward);
}

export function* watchProccessCodeTabOpenning() {
    yield takeEvery(PROCCESS_CODE_TAB_OPENNING, onProccessCodeTabOpenning);
}

export function* watchYearTabOpenning() {
    yield takeEvery(YEAR_TAB_OPENNING, onYearTabOpenning);
}

export function* watchCountryTabOpenning() {
    yield takeEvery(COUNTRY_TAB_OPENNING, onCountryTabOpenning);
}

export function* watchArticleCode22Supplier() {
    yield takeEvery(ARTICLE_CODE22_SUPPLIER, onArticleCode22Supplier);
}

export function* watchArticleCodeCountrySupplier() {
    yield takeEvery(ARTICLE_CODE_COUNTRY_SUPPLIER, onArticleCodeCountrySupplier);
}

export function* watchCountrySupplierInfo() {
    yield takeEvery(COUNTRY_SUPPLIER_INFO, onCountrySupplierInfo);
}

export function* watchSupplierInfo() {
    yield takeEvery(SUPPLIER_INFO, onSupplierInfo);
}

export function* watchMedDescriptionRazonabilidad() {
    yield takeEvery(MED_DESCRIPTION_RAZONABILIDAD, onMedDescriptionRazonabilidad);
}

export function* watchListArticleRazonabilidad() {
    yield takeEvery(LIST_ARTICLE_RAZONABILIDAD, onListArticleRazonabilidad);
}

export function* watchCountryAward() {
    yield takeEvery(COUNTRY_AWARD, onCountryAward);
}

export function* watchRole() {
    yield takeEvery(ROLE, onRole);
}

export function* watchRoleOrp() {
    yield takeEvery(ROLE_ORP, onRoleOrp);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onRouteAdministrationGroupAsync = async () => {
  let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/route_administration_group', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
    return { data:response };
};

const onDosageFormGroupAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/dosage_form_group', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
    return { data: response };
};

const onRouteAdministrationAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/route_administration', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onDosageFormAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/dosage_form', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onDispensingUnitAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/dispensing_unit', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onUnspscAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/unspsc', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onUnspscFamilyAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/unspsc_family', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onUnspscClassAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/unspsc_class', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onActiveIngredientCode20Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/active_ingredient_code20', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onDosageFormCode20Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/dosage_form_code20', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};


const onMedDescriptionCode20Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/med_description_code20', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onSourceCode20Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/source_code20', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onProjectAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/project', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onArticleCode22Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/article_code22', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onBidderAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/bidder', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onProcessCodeAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/process_code', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCountryBidAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/country_bid', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onMedDescriptionCode22Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/med_description_code22', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onArticleTypeAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/article_type', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onArticleGroupAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/article_group', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onCountrySupplierAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/country_supplier', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onSupplierTypeAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/supplier_type', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onPublicationTypeAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/publication_type', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onPublicationFormatAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/publication_format', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onPublicationStatusAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/publication_status', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onPublicationProjectAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/publication_project', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onCountryOpenningAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/country_openning', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onCountrySourceCode22Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/country_source_code22', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onMedDescriptionCode22OrpAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/med_description_code22_orp', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onSourceCode22Async = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/source_code22', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onProccessYearAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/proccess_year', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onProcessCodeBidAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/process_code_bid', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onAnioPriceCode22Async = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/anio_price_code22', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onProcessCodeBidderAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/process_code_bidder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onProccessYearBidderAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/proccess_year_bidder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onLoteStateAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/lote_state', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onYearDemandAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/year_demand', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onYearGob360Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/year_gob360', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onInstitutionGob360Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/institution_gob360', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onProcessCodeOpeningAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/process_code_opening', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onUnitPriceAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/unit_price', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onUnitPriceTransaccionesAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/unit_price', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onListArticleOrpCode22Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/articleListOrp', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onListArticleCodeCountryAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/articleCodeCountry', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onListArticleCodeCountryBidderAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/articleCodeCountryBidder', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCountryTabAwardAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/country_openning_tab_award', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onProccessCodeTabAwardAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/process_code_tab_award', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onYearTabAwardAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/proccess_year_tab_award', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onProccessCodeTabOpenningAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/process_code_tab_openning', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onYearTabOpenningAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/year_tab_openning', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCountryTabOpenningAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/country_tab_openning', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onArticleCode22SupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/article_code22_supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onArticleCodeCountrySupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/article_code_country_supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCountrySupplierInfoAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/country_supplier_info', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSupplierInfoAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/supplier_info', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onMedDescriptionRazonabilidadAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/med_description_razonabilidad', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onListArticleRazonabilidadAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/list_article_razonabilidad', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCountryAwardAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/country_award', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRoleAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/role', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRoleOrpAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/role_orp', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};



function* onRouteAdministrationGroup(data) {
  try {
      const response = yield call(onRouteAdministrationGroupAsync, data);
      yield put(RouteAdministrationGroupSuccess(response.data));
  } catch (error) {
      yield put(RouteAdministrationGroupError(error));
  }
}

function* onDosageFormGroup(data) {
    try {
        const response = yield call(onDosageFormGroupAsync, data);
        yield put(DosageFormGroupSuccess(response.data));
    } catch (error) {
        yield put(DosageFormGroupError(error));
    }
}

function* onRouteAdministration(data) {
    try {
        const response = yield call(onRouteAdministrationAsync, data);
        yield put(RouteAdministrationSuccess(response.data));
    } catch (error) {
        yield put(RouteAdministrationError(error));
    }
}

function* onDosageForm(data) {
    try {
        const response = yield call(onDosageFormAsync, data);
        yield put(DosageFormSuccess(response.data));
    } catch (error) {
        yield put(DosageFormError(error));
    }
}

function* onDispensingUnit(data) {
    try {
        const response = yield call(onDispensingUnitAsync, data);
        yield put(DispensingUnitSuccess(response.data));
    } catch (error) {
        yield put(DispensingUnitError(error));
    }
}

function* onUnspsc(data) {
    try {
        const response = yield call(onUnspscAsync, data);
        yield put(UnspscSuccess(response.data));
    } catch (error) {
        yield put(UnspscError(error));
    }
}

function* onUnspscFamily(data) {
    try {
        const response = yield call(onUnspscFamilyAsync, data);
        yield put(UnspscFamilySuccess(response.data));
    } catch (error) {
        yield put(UnspscFamilyError(error));
    }
}

function* onUnspscClass(data) {
    try {
        const response = yield call(onUnspscClassAsync, data);
        yield put(UnspscClassSuccess(response.data));
    } catch (error) {
        yield put(UnspscClassError(error));
    }
}

function* onActiveIngredientCode20(data) {
    try {
        const response = yield call(onActiveIngredientCode20Async, data);
        yield put(ActiveIngredientCode20Success(response.data));
    } catch (error) {
        yield put(ActiveIngredientCode20Error(error));
    }
}

function* onDosageFormCode20(data) {
    try {
        const response = yield call(onDosageFormCode20Async, data);
        yield put(DosageFormCode20Success(response.data));
    } catch (error) {
        yield put(DosageFormCode20Error(error));
    }
}

function* onMedDescriptionCode20(data) {
    try {
        const response = yield call(onMedDescriptionCode20Async, data);
        yield put(MedDescriptionCode20Success(response.data));
    } catch (error) {
        yield put(MedDescriptionCode20Error(error));
    }
}

function* onSourceCode20(data) {
    try {
        const response = yield call(onSourceCode20Async, data);
        yield put(SourceCode20Success(response.data));
    } catch (error) {
        yield put(SourceCode20Error(error));
    }
}

function* onProject(data) {
    try {
        const response = yield call(onProjectAsync, data);
        yield put(ProjectSuccess(response.data));
    } catch (error) {
        yield put(ProjectError(error));
    }
}

function* onArticleCode22(data) {
    try {
        const response = yield call(onArticleCode22Async, data);
        yield put(ArticleCode22Success(response.data));
    } catch (error) {
        yield put(ArticleCode22Error(error));
    }
}

function* onBidder(data) {
    try {
        const response = yield call(onBidderAsync, data);
        yield put(BidderSuccess(response.data));
    } catch (error) {
        yield put(BidderError(error));
    }
}

function* onProcessCode(data) {
    try {
        const response = yield call(onProcessCodeAsync, data.payload);
        yield put(ProcessCodeSuccess(response.data));
    } catch (error) {
        yield put(ProcessCodeError(error));
    }
}

function* onCountryBid(data) {
    try {
        const response = yield call(onCountryBidAsync, data);
        yield put(CountryBidSuccess(response.data));
    } catch (error) {
        yield put(CountryBidError(error));
    }
}

function* onMedDescriptionCode22(data) {
    try {
        const response = yield call(onMedDescriptionCode22Async, data);
        yield put(MedDescriptionCode22Success(response.data));
    } catch (error) {
        yield put(MedDescriptionCode22Error(error));
    }
}

function* onArticleType(data) {
    try {
        const response = yield call(onArticleTypeAsync, data);
        yield put(ArticleTypeSuccess(response.data));
    } catch (error) {
        yield put(ArticleTypeError(error));
    }
}

function* onArticleGroup(data) {
    try {
        const response = yield call(onArticleGroupAsync, data);
        yield put(ArticleGroupSuccess(response.data));
    } catch (error) {
        yield put(ArticleGroupError(error));
    }
}

function* onCountrySupplier(data) {
    try {
        const response = yield call(onCountrySupplierAsync, data);
        yield put(CountrySupplierSuccess(response.data));
    } catch (error) {
        yield put(CountrySupplierError(error));
    }
}

function* onSupplierType(data) {
    try {
        const response = yield call(onSupplierTypeAsync, data);
        yield put(SupplierTypeSuccess(response.data));
    } catch (error) {
        yield put(SupplierTypeError(error));
    }
}

function* onPublicationType(data) {
    try {
        const response = yield call(onPublicationTypeAsync, data);
        yield put(PublicationTypeSuccess(response.data));
    } catch (error) {
        yield put(PublicationTypeError(error));
    }
}

function* onPublicationFormat(data) {
    try {
        const response = yield call(onPublicationFormatAsync, data);
        yield put(PublicationFormatSuccess(response.data));
    } catch (error) {
        yield put(PublicationFormatError(error));
    }
}

function* onPublicationStatus(data) {
    try {
        const response = yield call(onPublicationStatusAsync, data);
        yield put(PublicationStatusSuccess(response.data));
    } catch (error) {
        yield put(PublicationStatusError(error));
    }
}

function* onPublicationProject(data) {
    try {
        const response = yield call(onPublicationProjectAsync, data);
        yield put(PublicationProjectSuccess(response.data));
    } catch (error) {
        yield put(PublicationProjectError(error));
    }
}

function* onCountryOpenning(data) {
    try {
        const response = yield call(onCountryOpenningAsync, data);
        yield put(CountryOpenningSuccess(response.data));
    } catch (error) {
        yield put(CountryOpenningError(error));
    }
}

function* onCountrySourceCode22(data) {
    try {
        const response = yield call(onCountrySourceCode22Async, data);
        yield put(CountrySourceCode22Success(response.data));
    } catch (error) {
        yield put(CountrySourceCode22Error(error));
    }
}

function* onMedDescriptionCode22Orp(data) {
    try {
        const response = yield call(onMedDescriptionCode22OrpAsync, data);
        yield put(MedDescriptionCode22OrpSuccess(response.data));
    } catch (error) {
        yield put(MedDescriptionCode22OrpError(error));
    }
}

function* onSourceCode22(data) {
    try {
        const response = yield call(onSourceCode22Async, data.payload);
        yield put(SourceCode22Success(response.data));
    } catch (error) {
        yield put(SourceCode22Error(error));
    }
}

function* onProccessYear(data) {
    try {
        const response = yield call(onProccessYearAsync, data.payload);
        yield put(ProccessYearSuccess(response.data));
    } catch (error) {
        yield put(ProccessYearError(error));
    }
}

function* onProcessCodeBid(data) {
    try {
        const response = yield call(onProcessCodeBidAsync, data.payload);
        yield put(ProcessCodeBidSuccess(response.data));
    } catch (error) {
        yield put(ProcessCodeBidError(error));
    }
}

function* onAnioPriceCode22(data) {
    try {
        const response = yield call(onAnioPriceCode22Async, data.payload);
        yield put(AnioPriceCode22Success(response.data));
    } catch (error) {
        yield put(AnioPriceCode22Error(error));
    }
}

function* onProccessYearBidder(data) {
    try {
        const response = yield call(onProccessYearBidderAsync, data.payload);
        yield put(ProccessYearBidderSuccess(response.data));
    } catch (error) {
        yield put(ProccessYearBidderError(error));
    }
}

function* onProcessCodeBidder(data) {
    try {
        const response = yield call(onProcessCodeBidderAsync, data.payload);
        yield put(ProcessCodeBidderSuccess(response.data));
    } catch (error) {
        yield put(ProcessCodeBidderError(error));
    }
}

function* onLoteState(data) {
    try {
        const response = yield call(onLoteStateAsync, data.payload);
        yield put(LoteStateSuccess(response.data));
    } catch (error) {
        yield put(LoteStateError(error));
    }
}

function* onYearDemand(data) {
    try {
        const response = yield call(onYearDemandAsync, data.payload);
        yield put(YearDemandSuccess(response.data));
    } catch (error) {
        yield put(YearDemandError(error));
    }
}

function* onYearGob360(data) {
    try {
        const response = yield call(onYearGob360Async, data);
        yield put(YearGob360Success(response.data));
    } catch (error) {
        yield put(YearGob360Error(error));
    }
}

function* onInstitutionGob360(data) {
    try {
        const response = yield call(onInstitutionGob360Async, data);
        yield put(InstitutionGob360Success(response.data));
    } catch (error) {
        yield put(InstitutionGob360Error(error));
    }
}

function* onProcessCodeOpening(data) {
    try {
        const response = yield call(onProcessCodeOpeningAsync, data.payload);
        yield put(ProcessCodeOpeningSuccess(response.data));
    } catch (error) {
        yield put(ProcessCodeOpeningError(error));
    }
}

function* onUnitPrice(data) {
    try {
        const response = yield call(onUnitPriceAsync, data.payload);
        yield put(UnitPriceSuccess(response.data));
    } catch (error) {
        yield put(UnitPriceError(error));
    }
}

function* onUnitPriceTransacciones(data) {
    try {
        const response = yield call(onUnitPriceTransaccionesAsync, data.payload);
        yield put(UnitPriceTransaccionesSuccess(response.data));
    } catch (error) {
        yield put(UnitPriceTransaccionesError(error));
    }
}

function* onListArticleOrpCode22(data) {
    try {
        const response = yield call(onListArticleOrpCode22Async, data);
        yield put(ListArticleOrpCode22Success(response.data));
    } catch (error) {
        yield put(ListArticleOrpCode22Error(error));
    }
}

function* onListArticleCodeCountry(data) {
    try {
        const response = yield call(onListArticleCodeCountryAsync, data);
        yield put(ListArticleCodeCountrySuccess(response.data));
    } catch (error) {
        yield put(ListArticleCodeCountryError(error));
    }
}

function* onListArticleCodeCountryBidder(data) {
    try {
        const response = yield call(onListArticleCodeCountryBidderAsync, data);
        yield put(ListArticleCodeCountryBidderSuccess(response.data));
    } catch (error) {
        yield put(ListArticleCodeCountryBidderError(error));
    }
}

function* onCountryTabAward(data) {
    try {
        const response = yield call(onCountryTabAwardAsync, data);
        yield put(CountryTabAwardSuccess(response.data));
    } catch (error) {
        yield put(CountryTabAwardError(error));
    }
}

function* onProccessCodeTabAward(data) {
    try {
        const response = yield call(onProccessCodeTabAwardAsync, data.payload);
        yield put(ProccessCodeTabAwardSuccess(response.data));
    } catch (error) {
        yield put(ProccessCodeTabAwardError(error));
    }
}

function* onYearTabAward(data) {
    try {
        const response = yield call(onYearTabAwardAsync, data.payload);
        yield put(YearTabAwardSuccess(response.data));
    } catch (error) {
        yield put(YearTabAwardError(error));
    }
}

function* onProccessCodeTabOpenning(data) {
    try {
        const response = yield call(onProccessCodeTabOpenningAsync, data.payload);
        yield put(ProccessCodeTabOpenningSuccess(response.data));
    } catch (error) {
        yield put(ProccessCodeTabOpenningError(error));
    }
}

function* onYearTabOpenning(data) {
    try {
        const response = yield call(onYearTabOpenningAsync, data.payload);
        yield put(YearTabOpenningSuccess(response.data));
    } catch (error) {
        yield put(YearTabOpenningError(error));
    }
}

function* onCountryTabOpenning(data) {
    try {
        const response = yield call(onCountryTabOpenningAsync, data.payload);
        yield put(CountryTabOpenningSuccess(response.data));
    } catch (error) {
        yield put(CountryTabOpenningError(error));
    }
}

function* onArticleCode22Supplier(data) {
    try {
        const response = yield call(onArticleCode22SupplierAsync, data.payload);
        yield put(ArticleCode22SupplierSuccess(response.data));
    } catch (error) {
        yield put(ArticleCode22SupplierError(error));
    }
}

function* onArticleCodeCountrySupplier(data) {
    try {
        const response = yield call(onArticleCodeCountrySupplierAsync, data.payload);
        yield put(ArticleCodeCountrySupplierSuccess(response.data));
    } catch (error) {
        yield put(ArticleCodeCountrySupplierError(error));
    }
}

function* onCountrySupplierInfo(data) {
    try {
        const response = yield call(onCountrySupplierInfoAsync, data.payload);
        yield put(CountrySupplierInfoSuccess(response.data));
    } catch (error) {
        yield put(CountrySupplierInfoError(error));
    }
}

function* onSupplierInfo(data) {
    try {
        const response = yield call(onSupplierInfoAsync, data.payload);
        yield put(SupplierInfoSuccess(response.data));
    } catch (error) {
        yield put(SupplierInfoError(error));
    }
}

function* onMedDescriptionRazonabilidad(data) {
    try {
        const response = yield call(onMedDescriptionRazonabilidadAsync, data.payload);
        yield put(MedDescriptionRazonabilidadSuccess(response.data));
    } catch (error) {
        yield put(MedDescriptionRazonabilidadError(error));
    }
}

function* onListArticleRazonabilidad(data) {
    try {
        const response = yield call(onListArticleRazonabilidadAsync, data.payload);
        yield put(ListArticleRazonabilidadSuccess(response.data));
    } catch (error) {
        yield put(ListArticleRazonabilidadError(error));
    }
}

function* onCountryAward(data) {
    try {
        const response = yield call(onCountryAwardAsync, data.payload);
        yield put(CountryAwardSuccess(response.data));
    } catch (error) {
        yield put(CountryAwardError(error));
    }
}

function* onRole(data) {
    try {
        const response = yield call(onRoleAsync, data.payload);
        yield put(RoleSuccess(response.data));
    } catch (error) {
        yield put(RoleError(error));
    }
}

function* onRoleOrp(data) {
    try {
        const response = yield call(onRoleOrpAsync, data.payload);
        yield put(RoleOrpSuccess(response.data));
    } catch (error) {
        yield put(RoleOrpError(error));
    }
}

export default function* rootSaga() {
  yield all([
      fork(watchRouteAdministrationGroup),
      fork(watchDosageFormGroup),
      fork(watchRouteAdministration),
      fork(watchDosageForm),
      fork(watchDispensingUnit),
      fork(watchUnspsc),
      fork(watchUnspscFamily),
      fork(watchUnspscClass),
      fork(watchActiveIngredientCode20),
      fork(watchDosageFormCode20),
      fork(watchMedDescriptionCode20),
      fork(watchSourceCode20),
      fork(watchProject),
      fork(watchArticleCode22),
      fork(watchBidder),
      fork(watchProcessCode),
      fork(watchCountryBid),
      fork(watchMedDescriptionCode22),
      fork(watchArticleType),
      fork(watchArticleGroup),
      fork(watchCountrySupplier),
      fork(watchSupplierType),
      fork(watchPublicationType),
      fork(watchPublicationFormat),
      fork(watchPublicationStatus),
      fork(watchPublicationProject),
      fork(watchCountryOpenning),
      fork(watchProcessCodeBid),
      fork(watchCountrySourceCode22),
      fork(watchMedDescriptionCode22Orp),
      fork(watchSourceCode22),
      fork(watchProccessYear),
      fork(watchAnioPriceCode22),
      fork(watchProccessYearBidder),
      fork(watchProcessCodeBidder),
      fork(watchLoteState),
      fork(watchYearDemand),
      fork(watchYearGob360),
      fork(watchInstitutionGob360),
      fork(watchProcessCodeOpening),
      fork(watchUnitPrice),
      fork(watchUnitPriceTransacciones),
      fork(watchListArticleOrpCode22),
      fork(watchListArticleCodeCountry),
      fork(watchListArticleCodeCountryBidder),
      fork(watchCountryTabAward),
      fork(watchProccessCodeTabAward),
      fork(watchYearTabAward),
      fork(watchProccessCodeTabOpenning),
      fork(watchYearTabOpenning),
      fork(watchCountryTabOpenning),
      fork(watchArticleCode22Supplier),
      fork(watchArticleCodeCountrySupplier),
      fork(watchCountrySupplierInfo),
      fork(watchSupplierInfo),
      fork(watchMedDescriptionRazonabilidad),
      fork(watchCountryAward),
      fork(watchRole),
      fork(watchRoleOrp)
  ]);
}